module.exports = __webpack_public_path__ + "assets/img/nav_item_checkmark.svg";